import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Hero from './components/Hero';
import NacodaraSection from './components/NacodaraSection';
import MobileAppSection from './components/MobileAppSection';
import Footer from './components/Footer';
import About from './components/About';
import Contact from './components/Contact';
import { Toaster } from './components/ui/toaster';

function HomePage() {
  return (
    <>
      <Hero />
      <NacodaraSection />
      <MobileAppSection />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
